import { SETTINGS_ACTION_TYPES } from 'store/actions/settings.actions';

const initialState = {
  data: {},
  loading: false,
}

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SETTINGS_ACTION_TYPES.LOAD_SETTINGS:
    case SETTINGS_ACTION_TYPES.EDIT_SETTINGS:
      return { ...state, loading: true };
    case SETTINGS_ACTION_TYPES.SET_SETTINGS:
      return { data: payload, loading: false };
    case SETTINGS_ACTION_TYPES.SET_SETTINGS_LOADING:
      return { ...state, loading: !!payload };
    default:
      return state;
  }
}
